import styled from '@emotion/styled'
import { useAtomValue } from 'jotai'
import { ZoningDetailsList } from 'src/components/insights/zoning/details/list'
import { Shapes } from 'src/components/theme'
import { ParcelMap } from 'src/v2/components/parcel-map'
import { parcelZoning } from 'src/v2/state/owner-reveal/parcel-zoning'
import { selectedParcel } from 'src/v2/state/owner-reveal/sidebar'

const Container = styled.div`
  display: flex;
  padding: 0 16px;
  gap: 16px;

  > div {
    flex: 1;
  }
`

const MapWrapper = styled.div`
  border-radius: ${Shapes.borderRadius}px;
  overflow: hidden;
`

export const ParcelZoningDetailsContent = () => {
  const parcel = useAtomValue(selectedParcel)
  const zoning = useAtomValue(parcelZoning)

  return (
    <Container>
      <MapWrapper>
        <ParcelMap geometry={parcel?.geometry} mCode={zoning?.mCode} height={450} />
      </MapWrapper>
      <ZoningDetailsList details={zoning?.zoneDetails} />
    </Container>
  )
}
